import { Platform, StyleSheet } from 'react-native'
import type { Theme } from '../../../src/theme/getTheme'

export const getLeaguePlayerBoardsStyles = (theme: Theme, windowWidth: number) => {
  const comfortable = windowWidth >= 768
  const spacious = windowWidth >= 1024

  const cardRadius = spacious ? 28 : comfortable ? 27 : 26

  return StyleSheet.create({
    container: {
      width: '100%',
      gap: spacious ? 16 : comfortable ? 14 : 12,
    },
    modeBarRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start',
      marginBottom: spacious ? 6 : 4,
    },
    card: {
      width: '100%',
      backgroundColor: theme.background.card,
      borderRadius: cardRadius,
      borderWidth: 1,
      borderColor: theme.gray[200],
      paddingTop: spacious ? 14 : 12,
      paddingBottom: spacious ? 8 : 6,
      overflow: 'hidden',
      ...(Platform.OS === 'web'
        ? { boxShadow: '0 4px 24px rgba(0, 0, 0, 0.06)' as const }
        : {
            shadowColor: theme.black,
            shadowOffset: { width: 0, height: 6 },
            shadowOpacity: 0.08,
            shadowRadius: 16,
            elevation: 6,
          }),
    },
    headerRow: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: spacious ? 16 : 12,
      paddingBottom: spacious ? 10 : 8,
      borderBottomWidth: StyleSheet.hairlineWidth,
      borderBottomColor: theme.gray[200],
      gap: 10,
    },
    headerRank: {
      width: spacious ? 28 : 24,
    },
    headerPlayer: {
      flex: 1,
    },
    headerStat: {
      width: spacious ? 44 : 40,
      alignItems: 'flex-end',
    },
    headerLabel: {
      fontSize: spacious ? 10 : 9,
      fontWeight: '700',
      color: theme.gray[500],
      letterSpacing: 0.3,
      textTransform: 'uppercase',
    },
    headerLabelEnd: {
      fontSize: spacious ? 10 : 9,
      fontWeight: '700',
      color: theme.gray[500],
      letterSpacing: 0.3,
      textTransform: 'uppercase',
      textAlign: 'right',
      width: '100%',
    },
    row: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: spacious ? 16 : 12,
      paddingVertical: spacious ? 10 : 9,
      borderBottomWidth: StyleSheet.hairlineWidth,
      borderBottomColor: theme.gray[100],
      gap: 10,
    },
    rowLast: {
      borderBottomWidth: 0,
    },
    rank: {
      width: spacious ? 28 : 24,
    },
    rankText: {
      fontSize: spacious ? 14 : 13,
      fontWeight: '600',
      color: theme.gray[700],
    },
    playerCell: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      gap: spacious ? 10 : 8,
      minWidth: 0,
    },
    avatarKitRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: spacious ? 6 : 5,
      flexShrink: 0,
    },
    teamKitColumn: {
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    },
    avatar: {
      width: spacious ? 32 : 28,
      height: spacious ? 32 : 28,
      borderRadius: spacious ? 16 : 14,
      backgroundColor: theme.gray[100],
    },
    playerMeta: {
      flex: 1,
      minWidth: 0,
    },
    playerName: {
      fontSize: spacious ? 14 : 13,
      fontWeight: '600',
      color: theme.black,
    },
    teamName: {
      fontSize: spacious ? 12 : 11,
      fontWeight: '500',
      color: theme.gray[500],
      marginTop: 1,
    },
    statCell: {
      width: spacious ? 44 : 40,
      alignItems: 'flex-end',
    },
    statValue: {
      fontSize: spacious ? 15 : 14,
      fontWeight: '800',
      color: theme.black,
    },
    emptyWrap: {
      paddingVertical: spacious ? 32 : 24,
      alignItems: 'center',
      justifyContent: 'center',
    },
    emptyText: {
      fontSize: spacious ? 14 : 13,
      color: theme.gray[500],
    },
  })
}
